export const homeFr = {
  // Hero section
  heroTitle: "Elle Peut. Elle Va. Elle L'a Fait.",
  heroSubtitle: "Un mouvement né de la résilience, construit pour chaque femme à qui on a dit 'tu ne peux pas.'",
  heroButton: "Rejoindre Notre Communauté",
  
  // Story section
  storyTitle: "De la Lutte à la Force",
  storyText1: "SheCan est né de mon propre parcours de dépassement de l'adversité. En tant que femme qui a fait face à d'innombrables obstacles et entendu 'tu ne peux pas' plus de fois que je ne peux compter, j'ai décidé de leur prouver qu'ils avaient tort.",
  storyText2: "Ce mouvement est pour chaque femme qui a été sous-estimée, négligée ou à qui on a dit que ses rêves étaient trop grands. Ensemble, nous réécrivons le récit.",
  storyButton: "Lire Mon Histoire",
  
  // Community section
  communityTitle: "Rejoignez une Communauté de Femmes Inarrêtables",
  communitySubtitle: "Connectez-vous, grandissez et prospérez ensemble",
  communityFeature1: "Réseau de Soutien",
  communityFeature1Text: "Connectez-vous avec des femmes partageant les mêmes idées qui comprennent votre parcours",
  communityFeature2: "Événements Exclusifs",
  communityFeature2Text: "Accédez à des ateliers, webinaires et opportunités de réseautage",
  communityFeature3: "Ressources et Outils",
  communityFeature3Text: "Obtenez des ressources pratiques pour vous aider à atteindre vos objectifs",
  communityButton: "Explorer la Communauté",
  
  // Featured Products
  productsTitle: "Renforcez Votre Parcours",
  productsSubtitle: "Produits sélectionnés pour vous inspirer et vous soutenir",
  
  // Testimonials
  testimonialsTitle: "Histoires de Transformation",
  testimonial1: "SheCan m'a donné le courage de créer ma propre entreprise. Le soutien de la communauté est incroyable!",
  testimonial1Author: "Sarah Johnson",
  testimonial1Role: "Entrepreneure",
  testimonial2: "J'ai trouvé ma voix et ma tribu ici. Ce mouvement a changé ma vie.",
  testimonial2Author: "Maria Garcia",
  testimonial2Role: "Écrivaine",
  testimonial3: "Les ressources et le soutien m'ont aidée à naviguer ma transition de carrière avec confiance.",
  testimonial3Author: "Emily Chen",
  testimonial3Role: "Coach de Carrière"
};

export default homeFr;
